module.exports = __webpack_public_path__ + "img/violet_056.ce7a0076.png";